module.exports = __webpack_public_path__ + "img/19Hayes.df77ef75.png";